import { ListViewBody, ListViewLabel } from '@/components/ListView';
import { Single } from '@moneyforward/ap-frontend-components';
import { FC } from 'react';
import { ApprovalStepProps } from '../../types';
import { ApprovalGroup } from '../ApprovalGroup';
import { ApprovalStepHeading } from '../ApprovalStepHeading';

export const ApprovalStep: FC<ApprovalStepProps> = ({ step }) => {
  const isShowCondition = !!step?.groups && step?.groups?.length > 1;
  return (
    <Single>
      <ListViewLabel>
        <ApprovalStepHeading
          condition={step.condition}
          stepName={step.name}
          status={step.status}
          isShowCondition={isShowCondition}
        />
      </ListViewLabel>
      <ListViewBody>
        <ApprovalGroup groups={step.groups} />
      </ListViewBody>
    </Single>
  );
};
